module.exports = __webpack_public_path__ + "db5c2e6b2a0b487cd819328501f33bb8.png";